import { notification } from 'antd';
import { modalNames } from '../../../shared/configs/modal';
import { State, StateContext } from '../base/state';
import { resultCodesMap, stateTypes } from '../constants';

export class Context extends StateContext {
  constructor(controller) {
    super({
      controller,
      InitialInstance: InitialState,
      eventType: stateTypes.save,
    });
  }

  _invalidateRoomsAndIntervals() {
    this.controller.api.invalidateRooms();
    this.controller.api.invalidateIntervals();
  }

  _onSuccess() {
    const { reset, modal } = this.controller;

    this.transitionTo(new SuccessState());

    modal.closeAndKeepProps(modalNames.setupIntervalForRegistration);

    this._invalidateRoomsAndIntervals();

    reset();
  }

  async updateRegistration({ intervalId, withExpert, byProxy }) {
    this.transitionTo(new LoadingState());

    const { selectedOwnerState, addressState, api } = this.controller;

    const result = await api.updateRegistration({
      intervalId,
      clientId: selectedOwnerState.state.payload.value.id,
      addressId: addressState.state.payload.value.id,
      withExpert,
      byProxy,
    });

    if (result === 'Error') {
      this.transitionTo(new ErrorState());
      return;
    }

    if (result.code === resultCodesMap.updateRecord.hasResult) {
      notification.info({
        message: result.message ?? 'По этой записи уже есть результат приемки',
      });
    }

    this._onSuccess();
  }

  async save({ intervalId, withExpert, byProxy, fnName }) {
    this.transitionTo(new LoadingState());

    const { selectedOwnerState, addressState, api } = this.controller;

    const fn = api[fnName];

    const result = await fn({
      intervalId,
      clientId: selectedOwnerState.state.payload.value.id,
      addressId: addressState.state.payload.value.id,
      withExpert,
      byProxy,
    });

    if (result === 'Error') {
      this.transitionTo(new ErrorState());
      return;
    }

    const { message, code } = result;

    if (code !== resultCodesMap.success) {
      this.transitionTo(new NotAvailableState(message));
      return;
    }

    this._onSuccess();
  }
}

export class InitialState extends State {
  constructor() {
    super({ status: 'idle' });
  }
}

export class LoadingState extends State {
  constructor() {
    super({ status: 'loading' });
  }
}

export class ErrorState extends State {
  constructor() {
    super({
      status: 'error',
      message:
        'Не удалось записать на выбранный интервал. Попробуйте еще раз. Если это не первая попытка, обратитесь в техподдержку',
    });
  }
}

export class NotAvailableState extends State {
  constructor(message, code) {
    super({
      status: 'notAvailable',
      message: message || 'Невозможно записаться на выбранный интервал',
      code: code ?? resultCodesMap.unknownError,
    });
  }
}

export class SuccessState extends State {
  constructor() {
    super({ status: 'success' });
  }
}
